import vuexLocalstorage from './vuexLocalStorage'

// An singleton store for all to use.

let store
const observers = []
const storeService = {
  get() {
    if (!store) {
      throw new Error('Store has not been set')
    }
    return store
  },

  set(_) {
    // Record the store.
    store = _

    return Promise.resolve(_).then((_s) => {
      // Notify observers of store.
      observers.forEach(fn => fn(store))
    })
  },

  observe(fn) {
    observers.push(fn)
    if (store) {
      fn(store)
    }
  },

  get userName() {
    return vuexLocalstorage.userName
  },

  async setUserName(_) {
    await vuexLocalstorage.setUserName(_)
    store.set('global/settings@user.email', _)
  },

  get roles() {
    return vuexLocalstorage.roles
  },

  set roles(_) {
    vuexLocalstorage.roles = _
    store.set('global/settings@user.roles', _)
  }

}
export { storeService as default }
